import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    el: "body",
    ui: {
        select: ".js-tab-select",
        heroInputForm: ".js-hero-input-form-wrap",
        inputClearX: ".js-input-clear-x"
    }
})
export default class ViewController extends Marionette.View<Backbone.Model>{
    constructor() {
        super();
        this.addEventListeners();
    }

    // --------------------------------
    // events
    // --------------------------------

    @on("click @ui.inputClearX")
    onClickInputClearX(JQueryEventObject: any) {
        const $nearestInput = $(JQueryEventObject.currentTarget).siblings("input");
        this.clearInput($nearestInput);
    }

    addEventListeners() {
        // stub
    }

    // --------------------------------
    // functions
    // --------------------------------

    init() {
        this.initializeSelect();
    }

    initializeSelect() {
        this.ui.select.selectpicker({
            "width": "100%"
        });
    }

    clearInput($inputToClear) {
        $inputToClear.val("");
    }

    onRender() {
        this.init();
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/hero-tabs/controller.ts